import React from "react";
import submit from "submit-form";
import Modal from "../../../../../parts/modal-new";
import SvgIcon from "../../../../../parts/SvgIcon";

export const CreateNewFoodModal = () => {
  /**
   * Function to redirect to create meal o create food modal
   */
  const handleRedirect = (destination) => {
    submit(`/actions/refresh/?`, {
      method: "GET",
      body: {
        "modal[type]": destination,
      },
    });
  };

  return (
    <Modal className="create-new-food-modal" title={"Create New"} backButton={true}>
      <div className="body">
        <button
          onClick={() => {
            handleRedirect("build-meal");
          }}
        >
          <div className="main-button-container">
            <div className="img-button">
              <SvgIcon src="/img/new-icons/food.svg" noFilterOnLight={false} />
            </div>
            <div className="info-button">
              <span>Create Meal</span>
              <span className="opacity-70 text-[0.75rem]">
                Prepare your own meal
              </span>
            </div>
          </div>
          <div className="arrow">
            <SvgIcon
              src="/img/new-icons/arrow-right.svg"
              alt="right"
              noFilterOnLight={false}
            />
          </div>
        </button>
        <button
          onClick={() => {
            handleRedirect("handle-meal-planner-food");
          }}
        >
          <div className="main-button-container">
            <div className="img-button">
              <SvgIcon src="/img/new-icons/meal.svg" noFilterOnLight={false} />
            </div>
            <div className="info-button">
              <span>Create Food</span>
              <span className="opacity-70 text-[0.75rem]">
                Design your ideal dish
              </span>
            </div>
          </div>
          <div className="arrow">
            <SvgIcon
              src="/img/new-icons/arrow-right.svg"
              alt="right"
              noFilterOnLight={false}
            />
          </div>
        </button>
      </div>
    </Modal>
  );
};